import { FormGroup } from "@angular/forms";

export function passwordMatchValidator(g: FormGroup) {
    const passwordControl = g.get('password');
    const confirmationControl = g.get('confirmation');

    if (!passwordControl || !confirmationControl)
        return null;

    return passwordControl.value === confirmationControl.value
        ? null : { 'mismatch': true };
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/passwordMatchValidator.ts